import BlockLink from "./modules/block-link.js"
import DomReady from "./modules/domready.js"

DomReady(() => {
  [...document.querySelectorAll(".js-block-link")].forEach((element) => {
    let blocklink = new BlockLink(element)
    blocklink.init()
  });
})
